import { ReactElement } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { InfoView } from '@client//common/components/InfoView';
import { FILTERS } from '@client/catalog/utils/facets';
import { getFiltersValuesFromSearchParams } from '@client/catalog/utils/filters';
import { useTranslate } from '@client/i18n/hooks';
import { ROUTES } from '@client/routes/components/Router';
import { useRouterPush, useUrlCreator } from '@client/routes/hooks';
import { Icon, ICON_NAME, ICON_SIZE } from '@lib/components/Icon';
import classNames from 'classnames';
import defaultImage from './assets/noresults.svg';
import { Props } from './';
import './NoResults.scss';

export const NoResults = ({ className, iconType, image = defaultImage }: Props): ReactElement => {
  const t = useTranslate();
  const push = useRouterPush();
  const urlCreator = useUrlCreator();
  const { search } = useLocation();
  const history = useHistory();
  const facetFilters = getFiltersValuesFromSearchParams(FILTERS.facetFilters, search);
  const hasFacetFilters = Object.keys(facetFilters).length > 0;

  const rootClassName = classNames('NoResults', className);

  return (
    <InfoView
      className={rootClassName}
      image={image}
      title={t('No results found.')}
      message={t('Your search has returned no results.')}
      iconType={iconType}
      {...hasFacetFilters && {
        buttons: {
          primary: {
            content: (
              <>
                <Icon name={ICON_NAME.arrowLeft} size={ICON_SIZE.small} className='NoResults-BackIcon' />
                {t('Back to previous results')}
              </>
            ),
            onClick: () => {
              history.length > 1 ? history.goBack() : push(urlCreator(ROUTES.homepage));
            },
          },
        },
      }}
    />
  );
};
